export const LOAD_USER_ROUTES = 'LOAD_USER_ROUTES'
export const LOAD_USER_ROUTES_LOADING = 'LOAD_USER_ROUTES_LOADING'
export const LOAD_USER_ROUTES_ERROR = 'LOAD_USER_ROUTES_ERROR'
export const LOAD_USER_ROUTES_SUCCESS = 'LOAD_USER_ROUTES_SUCCESS'

export const FETCH_ROUTE = 'FETCH_ROUTE'
export const FETCH_ROUTE_LOADING = 'FETCH_ROUTE_LOADING'
export const FETCH_ROUTE_SUCCESS = 'FETCH_ROUTE_SUCCESS'
export const FETCH_ROUTE_ERROR = 'FETCH_ROUTE_ERROR'

export const SEARCH_ROUTES = 'SEARCH_ROUTES'
export const SEARCH_ROUTES_LOADING = 'SEARCH_ROUTES_LOADING'
export const SEARCH_ROUTES_SUCCESS = 'SEARCH_ROUTES_SUCCESS'
export const SEARCH_ROUTES_ERROR = 'SEARCH_ROUTES_ERROR'

export const GET_LOCATION_SUGGESTIONS = 'GET_LOCATION_SUGGESTIONS'
export const GET_LOCATION_SUGGESTIONS_LOADING = 'GET_LOCATION_SUGGESTIONS_LOADING'
export const GET_LOCATION_SUGGESTIONS_SUCCESS = 'GET_LOCATION_SUGGESTIONS_SUCCESS'
export const GET_LOCATION_SUGGESTIONS_ERROR = 'GET_LOCATION_SUGGESTIONS_ERROR'

export const SELECT_ROUTE = 'SELECT_ROUTE'

export const CHECK_FOR_MAPS_SCRIPT = 'CHECK_FOR_MAPS_SCRIPT'
export const CHECK_FOR_MAPS_SCRIPT_LOADING = 'CHECK_FOR_MAPS_SCRIPT_LOADING'
export const CHECK_FOR_MAPS_SCRIPT_SUCCESS = 'CHECK_FOR_MAPS_SCRIPT_SUCCESS'
export const CHECK_FOR_MAPS_SCRIPT_ERROR = 'CHECK_FOR_MAPS_SCRIPT_ERROR'

export const LOAD_USER_SEARCH_PAGE = 'LOAD_USER_SEARCH_PAGE'
export const LOAD_USER_SEARCH_PAGE_LOADING = 'LOAD_USER_SEARCH_PAGE_LOADING'
export const LOAD_USER_SEARCH_PAGE_ERROR = 'LOAD_USER_SEARCH_PAGE_ERROR'
export const LOAD_USER_SEARCH_PAGE_SUCCESS = 'LOAD_USER_SEARCH_PAGE_SUCCESS'

export const SEARCH_MY_ROUTES = 'SEARCH_MY_ROUTES'
export const SEARCH_MY_ROUTES_LOADING = 'SEARCH_MY_ROUTES_LOADING'
export const SEARCH_MY_ROUTES_SUCCESS = 'SEARCH_MY_ROUTES_SUCCESS'
export const SEARCH_MY_ROUTES_ERROR = 'SEARCH_MY_ROUTES_ERROR'

export const GET_BOOKMARKED_ROUTES = 'GET_BOOKMARKED_ROUTES'
export const GET_BOOKMARKED_ROUTES_LOADING = 'GET_BOOKMARKED_ROUTES_LOADING'
export const GET_BOOKMARKED_ROUTES_ERROR = 'GET_BOOKMARKED_ROUTES_ERROR'
export const GET_BOOKMARKED_ROUTES_SUCCESS = 'GET_BOOKMARKED_ROUTES_SUCCESS'

export const DELETE_ROUTE = 'DELETE_ROUTE'
export const DELETE_ROUTE_LOADING = 'DELETE_ROUTE_LOADING'
export const DELETE_ROUTE_SUCCESS = 'DELETE_ROUTE_SUCCESS'
export const DELETE_ROUTE_ERROR = 'DELETE_ROUTE_ERROR'

export const DELETE_ROUTE_BOOKMARK = 'DELETE_ROUTE_BOOKMARK'
export const DELETE_ROUTE_BOOKMARK_LOADING = 'DELETE_ROUTE_BOOKMARK_BOOKMARK_LOADING'
export const DELETE_ROUTE_BOOKMARK_SUCCESS = 'DELETE_ROUTE_BOOKMARK_SUCCESS'
export const DELETE_ROUTE_BOOKMARK_ERROR = 'DELETE_ROUTE_BOOKMARK_ERROR'

export const TOGGLE_DELETE_ROUTE_MODAL = 'TOGGLE_DELETE_ROUTE_MODAL'



// WEBPACK FOOTER //
// ./src/services/routes/constants.js